import React, { useEffect } from 'react';
import styles from 'features/orders/index.module.scss';
import { useOrdersContext } from 'features/orders/use-orders';
import { CHANGE_CURRENT_PAGE, PAGE_ORDERS, useAppContext } from 'use-app';
import { OrderToolbar } from 'features/orders/order-toolbar';
import analytics from 'service/analytics';

const Orders = () => {
  const { state } = useOrdersContext();
  const { dispatch } = useAppContext();

  useEffect(() => {
    window.scrollTo(0, 0);
    analytics.track('消費頁_pageview');
  }, []);

  useEffect(() => {
    dispatch({
      type: CHANGE_CURRENT_PAGE,
      payload: PAGE_ORDERS,
    });
  }, [dispatch]);

  return (
    <div className={styles.main}>
      <div className={styles.title}>匯出明細</div>
      <div className={styles.desc}>匯出企業方案的消費明細</div>
      <div className={styles.content}>
        <OrderToolbar startAt={state.filterOption.startAt} endAt={state.filterOption.endAt} />
      </div>
    </div>
  );
};

export default Orders;
